module.exports = __webpack_public_path__ + "media/flags/ph-54a0a716.svg";